module.exports = __webpack_public_path__ + "img/framenew_box16.c38b7850.jpg";